import createStartListsPdf from './createStartListsPdf';
import { createAthleteRecord } from '../common';
import DownloadsPicker from '../DownloadsPicker';
import FileDownload from '../../../components/FileDownload';

import React from 'react';
import { mapValues } from 'lodash';

const createStartLists = (sessions, mode) => {
  switch (mode) {
    default:
      return sessions.map(session => ({
        title: `${session.number}: ${session.title}`,
        athletes: session.entries.map(createAthleteRecord),
      }));
  }
};

const StartListsDownload = ({ sessions, mode, meta, ...props }) => {
  const onFileContents = () => {
    return createStartListsPdf(createStartLists(sessions, mode, meta), meta);
  };
  return (
    <FileDownload
      mimeType="appication/pdf"
      fileName={`start-lists-${mode}.pdf`}
      onContents={onFileContents}
      {...props}
    />
  );
};

const StartListsDownloads = ({ sessions, meta }) => {
  const modes = mapValues(
    {
      all: 'All lists',
      template: 'Empty template',
      //...(process.env.NODE_ENV !== 'production' ? { test: 'Test list' } : {}),
    },
    (text, mode) => ({
      mode,
      text,
      download: (
        <StartListsDownload mode={mode} sessions={sessions} meta={meta} />
      ),
    }),
  );

  return <DownloadsPicker modes={modes} />;
};

export default StartListsDownloads;



// WEBPACK FOOTER //
// ./src/pages/Home/startLists/StartListsDownloads.js